import Vue from "vue";
import Router from "vue-router";
import login from "@/views/login";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    if (err && err.name !== "NavigationDuplicated") {
      return Promise.reject(err);
    }
  });
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => {
    if (err && err.name !== "NavigationDuplicated") {
      return Promise.reject(err);
    }
  });
};

export const constantRoutes = [
  {
    path: "/login",
    name: "登录",
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }
];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

export function resetRouter() {
  router.matcher = createRouter().matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js